/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TerminalDiagnosisEventNotification } from './TerminalDiagnosisEventNotification';
import {
    TerminalDiagnosisEventNotificationFromJSON,
    TerminalDiagnosisEventNotificationFromJSONTyped,
    TerminalDiagnosisEventNotificationToJSON,
    TerminalDiagnosisEventNotificationToJSONTyped,
} from './TerminalDiagnosisEventNotification';
import type { TerminalDiagnosisHostStatus } from './TerminalDiagnosisHostStatus';
import {
    TerminalDiagnosisHostStatusFromJSON,
    TerminalDiagnosisHostStatusFromJSONTyped,
    TerminalDiagnosisHostStatusToJSON,
    TerminalDiagnosisHostStatusToJSONTyped,
} from './TerminalDiagnosisHostStatus';
import type { TerminalDiagnosisPoiStatus } from './TerminalDiagnosisPoiStatus';
import {
    TerminalDiagnosisPoiStatusFromJSON,
    TerminalDiagnosisPoiStatusFromJSONTyped,
    TerminalDiagnosisPoiStatusToJSON,
    TerminalDiagnosisPoiStatusToJSONTyped,
} from './TerminalDiagnosisPoiStatus';

/**
 * 
 * @export
 * @interface TerminalDiagnosisResponse
 */
export interface TerminalDiagnosisResponse {
    /**
     * 
     * @type {Array<TerminalDiagnosisHostStatus>}
     * @memberof TerminalDiagnosisResponse
     */
    hostStatus: Array<TerminalDiagnosisHostStatus>;
    /**
     * 
     * @type {TerminalDiagnosisResponseKindEnum}
     * @memberof TerminalDiagnosisResponse
     */
    kind: TerminalDiagnosisResponseKindEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof TerminalDiagnosisResponse
     */
    loggedSaleIds: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof TerminalDiagnosisResponse
     */
    pspTerminalId: string;
    /**
     * 
     * @type {string}
     * @memberof TerminalDiagnosisResponse
     */
    serviceId: string;
    /**
     * 
     * @type {string}
     * @memberof TerminalDiagnosisResponse
     */
    additionalResponse?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TerminalDiagnosisResponse
     */
    errorCondition?: string | null;
    /**
     * 
     * @type {TerminalDiagnosisEventNotification}
     * @memberof TerminalDiagnosisResponse
     */
    eventNotification?: TerminalDiagnosisEventNotification | null;
    /**
     * 
     * @type {string}
     * @memberof TerminalDiagnosisResponse
     */
    failureMessage?: string | null;
    /**
     * 
     * @type {TerminalDiagnosisPoiStatus}
     * @memberof TerminalDiagnosisResponse
     */
    poiStatus?: TerminalDiagnosisPoiStatus | null;
    /**
     * 
     * @type {string}
     * @memberof TerminalDiagnosisResponse
     */
    result?: string | null;
}


/**
 * @export
 */
export const TerminalDiagnosisResponseKindEnum = {
    DIAGNOSIS_RESPONSE: 'DIAGNOSIS_RESPONSE',
    EVENT_NOTIFICATION: 'EVENT_NOTIFICATION',
    REQUEST_FAILURE: 'REQUEST_FAILURE'
} as const;
export type TerminalDiagnosisResponseKindEnum = typeof TerminalDiagnosisResponseKindEnum[keyof typeof TerminalDiagnosisResponseKindEnum];


/**
 * Check if a given object implements the TerminalDiagnosisResponse interface.
 */
export function instanceOfTerminalDiagnosisResponse(value: object): value is TerminalDiagnosisResponse {
    if (!('hostStatus' in value) || value['hostStatus'] === undefined) return false;
    if (!('kind' in value) || value['kind'] === undefined) return false;
    if (!('loggedSaleIds' in value) || value['loggedSaleIds'] === undefined) return false;
    if (!('pspTerminalId' in value) || value['pspTerminalId'] === undefined) return false;
    if (!('serviceId' in value) || value['serviceId'] === undefined) return false;
    return true;
}

export function TerminalDiagnosisResponseFromJSON(json: any): TerminalDiagnosisResponse {
    return TerminalDiagnosisResponseFromJSONTyped(json, false);
}

export function TerminalDiagnosisResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TerminalDiagnosisResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'hostStatus': ((json['hostStatus'] as Array<any>).map(TerminalDiagnosisHostStatusFromJSON)),
        'kind': json['kind'],
        'loggedSaleIds': json['loggedSaleIds'],
        'pspTerminalId': json['pspTerminalId'],
        'serviceId': json['serviceId'],
        'additionalResponse': json['additionalResponse'] === undefined ? undefined : json['additionalResponse'] === null ? null : json['additionalResponse'],
        'errorCondition': json['errorCondition'] === undefined ? undefined : json['errorCondition'] === null ? null : json['errorCondition'],
        'eventNotification': json['eventNotification'] === undefined ? undefined : json['eventNotification'] === null ? null : TerminalDiagnosisEventNotificationFromJSON(json['eventNotification']),
        'failureMessage': json['failureMessage'] === undefined ? undefined : json['failureMessage'] === null ? null : json['failureMessage'],
        'poiStatus': json['poiStatus'] === undefined ? undefined : json['poiStatus'] === null ? null : TerminalDiagnosisPoiStatusFromJSON(json['poiStatus']),
        'result': json['result'] === undefined ? undefined : json['result'] === null ? null : json['result'],
    };
}

export function TerminalDiagnosisResponseToJSON(json: any): TerminalDiagnosisResponse {
    return TerminalDiagnosisResponseToJSONTyped(json, false);
}

export function TerminalDiagnosisResponseToJSONTyped(value?: TerminalDiagnosisResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'hostStatus': ((value['hostStatus'] as Array<any>).map(TerminalDiagnosisHostStatusToJSON)),
        'kind': value['kind'],
        'loggedSaleIds': value['loggedSaleIds'],
        'pspTerminalId': value['pspTerminalId'],
        'serviceId': value['serviceId'],
        'additionalResponse': value['additionalResponse'],
        'errorCondition': value['errorCondition'],
        'eventNotification': TerminalDiagnosisEventNotificationToJSON(value['eventNotification']),
        'failureMessage': value['failureMessage'],
        'poiStatus': TerminalDiagnosisPoiStatusToJSON(value['poiStatus']),
        'result': value['result'],
    };
}

